<template>
  <div class="content">
    <DownloadPageList :downloadPageList="downloadPageList" :downloadPageListTitle="downloadPageListTitle" :itemSubtitleNeeded="false" />
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '~/stores/main';

  definePageMeta({ middleware: 'check-token' });

  const store = useMainStore();
  const route = useRoute();
  const categories = computed(() => store.categories);
  const downloadPageList = computed(() => {
    return categories.value
      .filter((category) => route.params.category == category.nodeId)
      .map((item) => ({
        nodeId: String(item.nodeId),
        external: { title: item.title || '' },
        nodes:
          item.nodes?.map((node) => ({
            id: String(node.id),
            nodeId: String(node.nodeId),
            productBlockType: node.productBlockType || '',
            resources: node.resources,
            external: typeof node.external === 'object' ? node.external : undefined,
            title: node.title,
            fileName: (node as any).fileName
          })) || []
      }));
  });
  const downloadPageListTitle = computed(() => {
    // Replace with actual logic for setProperFieldExternalFirst if needed
    return downloadPageList.value[0]?.external?.title || '';
  });
</script>
